import { FC } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import { CheckMarkFill } from '@o2/icons';

export interface AppBarVerifiedIconProps {
  isVerified: boolean;
}

const AppBarVerifiedIcon: FC<AppBarVerifiedIconProps> = ({ isVerified }) => {
  return isVerified ? (
    <CheckMarkFill color="success" fontSize="small" sx={{ ml: 1 }} />
  ) : (
    <HelpIcon fontSize="small" sx={{ color: 'warning.main', ml: 1 }} />
  );
};

export default AppBarVerifiedIcon;
